import { render, staticRenderFns } from "./EditArticle.vue?vue&type=template&id=1f00ef1e&scoped=true&"
import script from "./EditArticle.vue?vue&type=script&lang=js&"
export * from "./EditArticle.vue?vue&type=script&lang=js&"
import style0 from "./EditArticle.vue?vue&type=style&index=0&id=1f00ef1e&lang=scss&scoped=true&"
import style1 from "./EditArticle.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f00ef1e",
  null
  
)

export default component.exports